// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --swiper-navigation-size: 12px !important;
}

.gifting-page-title {
  text-align: center;
  margin-bottom: 2rem;
}

.gifting-selected-product-container {
  padding: 3rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  justify-content: space-between;
}

.gifting-selected-product-containers {
  padding: 3rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  justify-content: space-between;
}

.gifting-image-container {
  position: relative;
  /* text-align: center;*/
  margin: 0 0.2rem;
  width: 140px; 
}

.gifting-image-container-summary {
  position: relative;
  /* text-align: center;*/
  margin: 0 0.2rem;
  width: fit-content; 
}

.image-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.image-wrapper .remove-overlay {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-wrapper:hover .remove-overlay {
  opacity: 1;
}

.gift-image {
  max-width: 100%;
  border-radius: 5px;
}

.gift-image-in-summary-container {
  max-width: 45px;
  border-radius: 5px;
}

.gifting-box-content-table {
  width: -webkit-fill-available;
}

.gifting-box-content-table td {
  border: none;
  text-wrap: pretty;
}

@media (min-width: 768px) {
  .gifting-box-content {
    padding: 0 0 0 3rem;
  }
}

/* .gifting-subtotal-product-price {
  float: right;
  padding: 0 0.7em;
} */

/* .gift-image-bottom-summary {
  max-width: 20%;
} */

.gifting-image-bottom-container {
  /* max-width: 130px; */
  display: flex;
}

.mobile-selected-products-container.active {
  transition: all 0.5s;
  bottom: 0;
  position: fixed;
  z-index: 9;
  place-content: center;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.blinking-text {
  animation: blink 1s infinite;
}

.mobile-selected-products-container {
  background: #efe2e2;
  position: relative;
  display: flex;
  align-items: center;
  bottom: -74px;
  left: 0;
  z-index: 9;
  padding: 10px 0;
  width: 100%;
  transition: all 0.5s;
  min-height: 73px;
}

@media (min-width: 480px) {
  .gifting-pick {
    max-width: 65%;
  }

  .gifting-box-content {
    min-width: 35%;
  }

  .gifting-selected-product-container {
    display: flex;
  }

  .flex-desktop {
    display: flex;
  }

  .left {
    margin-right: 3.5rem;
  }

  .wrapping-right {
    max-width: 50%;
  }

  .wrapping-item-slide {
    width: 22% !important;
  }

  .mobile-selected-products-container {
    justify-content: space-around;
  }
}

@media (max-width: 480px) {
  .gifting-pick {
    max-width: 100%;
  }

  .gifting-box-content {
    min-width: 100%;
  }

  .gift-image {
    height: auto;
    object-fit: cover;
  }

  .wrapping-item-slide {
    width: 55% !important;
  }

  .gifting-selected-product-container {
    padding: 2rem 1rem;
  }

  .gifting-selected-product-containers {
    padding: 2rem 1rem;
  }

  .gifting-box-content {
    margin-top: 2rem;
  }

  .gifting-image-bottom-container {
    /* width: 20%; */
    /* margin-left: 1rem; */
  }

  .gifting-image-container {
    /* text-align: center; */
    margin: 0 0.2rem;
    width: 60px;
  }
}

.gifting-box-content {
  width: -webkit-fill-available;
}

/* product list */
.gifting-product-list-container {
  display: list-item;
  width: 100%;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(calc(15% - 20px), 1fr));
  grid-gap: 20px;
}

@media (max-width: 768px) {
  img.gift-image-bottom-summary {
    max-width: 45px;
    width: 45px;
  }
  .image-wrapper .remove-overlay {
    font-size: 12px;
  }

  .product-disclosure {
    margin: 0 !important;
    padding: 1rem !important;
  }

  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(calc(50% - 20px), 1fr));
  }

  .gifting-product-list-container {
    margin: 2rem 0;
  }

  .boxwrapping-container {
    padding: 3rem 1rem !important;
  }

  .mt-3-mobile {
    margin-top: 3rem;
  }

  .right {
    padding-left: 0 !important;
  }

  .boxwrapping-list {
    justify-content: space-between !important;
  }
}

.product-item {
  border: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f9f9f9;
  border-radius: 4px;
  width: fit-content;
}

.product-item-swiper {
  border: 0;
  margin-bottom: 0;
  display: -ms-flexbox;
  flex-direction: column;
  height: 100%;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.product-item .product-item-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 16px 16px;
  justify-content: space-between;
}

.product-item-swiper .product-item-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 16px 16px;
  justify-content: space-between;
}

@media (min-width: 847px) {
  .product-item .product-item-body {
    padding: 0 12px 12px;
  }

  /* .gifting-box-content {
    margin-left: 2rem;
  } */
}

.product-image {
  width: 100%;
  height: auto;
}

.product-name {
  margin: 18px 12px 0px;
  color: rgb(16, 16, 16);
}

.product-item .product-name-container .product-name {
  font-size: 1.1em;
  text-decoration: none;
  font-family: custom-body-font, Poppins, sans-serif;
  line-height: 1.1;
  display: block;
  font-weight: 400;
  min-height: 55px;
}

.product-item-swiper .product-name-container .product-name {
  font-size: 1.1em;
  text-decoration: none;
  font-family: custom-body-font, Poppins, sans-serif;
  line-height: 1.1;
  display: block;
  font-weight: 400;
  min-height: 55px;
}

.product-price {
  font-size: 1.1em;
  text-decoration: none;
  font-family: custom-body-font, roboto-fallback, sans-serif;
  line-height: 1.1;
  display: block;
  font-weight: 400;
  min-height: 20px;
  place-content: center;
  display: flex;
  flex-direction: column;
  color: rgb(16, 16, 16);
  /* padding: 0px 4px; */
}

.add-to-box-button {
  margin-top: 10px;
  padding: 0.6rem 0.5rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  text-transform: uppercase;
}

.add-to-box-button:hover {
  background-color: #6f1920;
  border: 1.5px solid #6f1920 !important;
  color: white !important;
}
.recipient-name-field {
  max-width: 530px;
  margin-top: 5rem;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.875rem + 2px);
  padding: 0.4375rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #303e48;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #303e48;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control-area {
  display: block;
  width: 100%;
  min-height: 240px;
  padding: 0.4375rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #303e48;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dbdcdc;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.message-on-card-container {
  width: 100%;
  display: inline-grid;
}

.card-message-field {
  max-width: 530px;
  margin-top: 3rem;
}

.card-message-field-no-message {
  max-width: 530px;
  margin: 1.5rem 0 0 0;
  margin-bottom: 3rem;
}

.h3 {
  font-family: custom-heading-font, andrade-pro-fallback, sans-serif;
  font-size: 1.5625rem;
  font-style: normal;
  line-height: 1.28;
  letter-spacing: -0.5px;
  color: #303e48;
}

.box-button-container {
  display: flex;
  min-height: 73px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.left {
  flex: 1;
  /* padding-right: 10px; */
}

.right {
  flex: 1;
  padding-left: 10px;
}

.wishcard-list {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}

.mt-3 {
  margin-top: 3rem;
}

.wishcard-item {
  /* width: calc(50% - 10px); */
  margin-bottom: 20px;
  border: 2px solid transparent;
  cursor: pointer;
  background-color: white;
  padding: 0.4rem;
  align-content: center;
  border-radius: 4px;
}

.wishcard-item.desktop {
  /* width: calc(25% - 10px); */
}

.wishcard-item.selected {
  border-color: #6f1920;
}

.wishcard-image {
  text-align: center;
  min-height: 210px;
  align-content: center;
  object-fit: contain;
}

.wishcard-details {
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
}

.wishcard-price {
  padding: 12px;
  font-size: 1.1em;
  text-decoration: none;
  font-family: custom-body-font, roboto-fallback, sans-serif;
  line-height: 1.1;
  display: block;
  font-weight: 400;
  min-height: 20px;
  place-content: center;
  display: flex;
  flex-direction: column;
  color: rgb(16, 16, 16);
}

.wishcard-name {
  padding: 12px;
  min-height: 60px;
  color: rgb(16, 16, 16);
}

.boxwrapping-left {
  margin-top: 3rem;
}

.boxwrapping-right {
  margin-top: 2rem;
}

.boxwrapping-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: unset;
}

.center-image-container {
  text-align: center;
  min-height: 210px;
  align-content: center;
}

.wrapping-item {
  /* width: calc(50% - 10px); */
  margin-bottom: 20px;
  border: 2px solid transparent;
  cursor: pointer;
  background-color: white;
  padding: 0.4rem;
  align-content: end;
  border-radius: 4px;
}

.wrapping-item.desktop {
  /* width: calc(25% - 10px); */
  margin-right: 0.5rem;
  align-content: end;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.wrapping-item.selected {
  border-color: #6f1920;
}

.boxwrapping-item.selected {
  border-color: #6f1920;
}

.boxwrapping-image {
  width: 100%;
  max-width: 100%;
  height: auto;
}

.boxwrapping-details {
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
}

.boxwrapping-price {
  padding: 12px;
  font-size: 1.1em;
  text-decoration: none;
  font-family: custom-body-font, roboto-fallback, sans-serif;
  line-height: 1.1;
  display: block;
  font-weight: 400;
  min-height: 20px;
  place-content: center;
  display: flex;
  flex-direction: column;
  color: rgb(16, 16, 16);
}

.boxwrapping-name {
  padding: 12px;
  min-height: 60px;
  color: rgb(16, 16, 16);
}

.boxwrapping-container {
  padding: 3rem;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.box-item {
  /* width: calc(50% - 10px); */
  margin-bottom: 20px;
  border: 2px solid transparent;
  cursor: pointer;
  background-color: white;
  padding: 0.4rem;
  border-radius: 4px;
}

.box-item.desktop {
  /* width: calc(25% - 10px); */
  margin-right: 0.5rem;
}
.box-item.selected {
  border-color: #6f1920;
}

.review-container {
  background: none;
}

.summary-gift-items {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.no-mb {
  margin-bottom: 0;
}

.gift-item-summary-container {
  background: #f9f9f9;
  border-radius: 5px;
  margin-top: 3rem;
  margin-right: 0.3rem;
  padding: 0.2rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}

.gift-summary-image-container {
  /* width: calc(25% - 3px); */
  width: calc(50% - 6px);
  display: flex;
  margin: 3px;
}

.gift-summary-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  background: white;
}

.personalized-item-container {
  background: #f9f9f9;
  border-radius: 5px;
  margin-top: 0.5rem;
  padding: 5px;
  width: 100%;
  align-content: center;
  display: flex;
}

.gifting-total-product-price {
  text-align: right;
  font-weight: bold;
}

.gifting-subtotal-product-price {
  font-size: 15px;
  color: #7d7d7d;
  text-align: right;
  font-weight: bold;
}

.color-circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
  border: 1px solid #d4d4d4;
}

.color-circle.selected {
  border: 1px solid #373737;
}

.size-rectangle {
  padding: 5px 10px;
  margin: 5px;
  border: 1px solid #d4d4d4;
  cursor: pointer;
  border-radius: 3px;
  display: inline-block;
}

.size-rectangle.selected {
  border: 1px solid black;
}

/* modal */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-close-button {
  position: absolute;
  top: 10px;
  right: 20px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-content {
  margin: 20px 10px;
}

.product-image-in-modal {
  width: 15rem;
  height: auto;
  border-radius: 5px;
}

.product-image-in-modal-container {
  text-align: -webkit-center;
  margin-bottom: 2rem;
}

.product-image-in-modal-container-content {
  /* margin: 0 2rem; */
  text-wrap: pretty;
}

.product-disclosure {
  width: 100%;
  background: #f9f9f9;
  margin: 1rem 0;
  padding: 1rem 3rem;
  text-align-last: left;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}

#cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

#cover-spin::after {
  content: '';
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: black;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.rp-card-gifting-option {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 15px;
}

.rp-card-gifting-option-values-container {
  display: flex;
  flex-direction: row;
  row-gap: 0.5rem;
  flex-wrap: wrap;
}

.product-price {
  font-size: 1.1em;
  text-decoration: none;
  font-family: custom-body-font, roboto-fallback, sans-serif;
  line-height: 1.1;
  display: block;
  font-weight: 400;
  min-height: 20px;
  place-content: center;
  display: flex;
  flex-direction: column;
  color: rgb(16, 16, 16);
}
.gift-set-product-image {
  /* max-width: 120px !important; */
  /* border-radius: 5px; */
  margin-bottom: 0.5rem;
}

.gift-set-option {
  background: #e2e2e291;
  padding: 2rem;
  border-radius: 5px;
  margin-top: 20px;
  /* margin: 1rem 0.5rem; Adjust margin for better spacing */
  /* border: 5px solid #f7f1f0; */
  cursor: pointer;
  transition: all 0.3s ease; /* Adding transition for smooth hover effect */
  width: -webkit-fill-available;
}

.gift-set-option:hover {
  transform: translateY(-5px); /* Move the option up by 5px on hover */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow on hover */
}

.gift-set-button-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* Use auto-fit for flexible grid */
  gap: 1rem; /* Gap between images */
}

@media screen and (max-width: 768px) {
  .gift-set-button-container {
    grid-template-columns: repeat(1, 1fr); /* On smaller screens, display one image per row */
  }

  .gift-set-product-image {
    /* max-width: 60px !important; */
  }

  .gift-set-images {
    display: flex;
    flex-flow: wrap;
    align-items: center;
  }
}

.gift-set-option-item {
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
}

.gift-set-images {
  display: flex;
  flex-flow: wrap;
  align-items: center;
}

.button-next-page {
  cursor: pointer;
  background: #6f1920;
  border-radius: 3px;
  color: white;
  width: 100%;
  padding: 0.6rem 1rem;
  margin-top: 1rem;
}

.button-next-page:hover {
  background: #2e1414 !important;
}

.swiper-button-prev,
.swiper-button-next {
  color: #000000 !important;
}

.svg-hover:hover {
  color: #6f1920;
}

.remove-icon{
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/modules/gifting/components/gifting.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EAEE,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAGlB,aAAa;EAGb,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,UAAU;EACV,eAAe;EACf,WAAW;EAEX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,uEAAuE;EACzE;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAGhB,aAAa;EAIb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAEhB,oBAAoB;EAIpB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EAGtB,OAAO;EACP,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EAGtB,OAAO;EACP,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;KAEG;AACL;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;EAC1D,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAGlB,wEAAwE;AAG1E;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAGlB,wEAAwE;AAG1E;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EAEE,kEAAkE;EAClE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EAGE,aAAa;EACb,gBAAgB;EAChB,WAAW;EAGX,8BAA8B;EAG9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;EAC1D,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;EAC1D,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,WAAW;EAIX,aAAa;EACb,eAAe;EACf,oCAAoC;AALtC;;AAQA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAElB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;EAC1D,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;EAC1D,+BAA+B;EAC/B,eAAe;EACf,yBAAyB,EAAE,8CAA8C;EACzE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B,EAAE,uCAAuC;EACpE,0CAA0C,EAAE,wBAAwB;AACtE;;AAEA;EACE,aAAa;EACb,2DAA2D,EAAE,mCAAmC;EAChG,SAAS,EAAE,uBAAuB;AACpC;;AAEA;EACE;IACE,qCAAqC,EAAE,kDAAkD;EAC3F;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[":root {\n  --swiper-navigation-size: 12px !important;\n}\n\n.gifting-page-title {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.gifting-selected-product-container {\n  padding: 3rem;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  justify-content: space-between;\n}\n\n.gifting-selected-product-containers {\n  padding: 3rem;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  justify-content: space-between;\n}\n\n.gifting-image-container {\n  position: relative;\n  /* text-align: center;*/\n  margin: 0 0.2rem;\n  width: 140px; \n}\n\n.gifting-image-container-summary {\n  position: relative;\n  /* text-align: center;*/\n  margin: 0 0.2rem;\n  width: fit-content; \n}\n\n.image-wrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.image-wrapper .remove-overlay {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.image-wrapper:hover .remove-overlay {\n  opacity: 1;\n}\n\n.gift-image {\n  max-width: 100%;\n  border-radius: 5px;\n}\n\n.gift-image-in-summary-container {\n  max-width: 45px;\n  border-radius: 5px;\n}\n\n.gifting-box-content-table {\n  width: -webkit-fill-available;\n}\n\n.gifting-box-content-table td {\n  border: none;\n  text-wrap: pretty;\n}\n\n@media (min-width: 768px) {\n  .gifting-box-content {\n    padding: 0 0 0 3rem;\n  }\n}\n\n/* .gifting-subtotal-product-price {\n  float: right;\n  padding: 0 0.7em;\n} */\n\n/* .gift-image-bottom-summary {\n  max-width: 20%;\n} */\n\n.gifting-image-bottom-container {\n  /* max-width: 130px; */\n  display: flex;\n}\n\n.mobile-selected-products-container.active {\n  -webkit-transition: all 0.5s;\n  transition: all 0.5s;\n  bottom: 0;\n  position: fixed;\n  z-index: 9;\n  place-content: center;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.blinking-text {\n  animation: blink 1s infinite;\n}\n\n.mobile-selected-products-container {\n  background: #efe2e2;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  bottom: -74px;\n  left: 0;\n  z-index: 9;\n  padding: 10px 0;\n  width: 100%;\n  -webkit-transition: all 0.5s;\n  transition: all 0.5s;\n  min-height: 73px;\n}\n\n@media (min-width: 480px) {\n  .gifting-pick {\n    max-width: 65%;\n  }\n\n  .gifting-box-content {\n    min-width: 35%;\n  }\n\n  .gifting-selected-product-container {\n    display: flex;\n  }\n\n  .flex-desktop {\n    display: flex;\n  }\n\n  .left {\n    margin-right: 3.5rem;\n  }\n\n  .wrapping-right {\n    max-width: 50%;\n  }\n\n  .wrapping-item-slide {\n    width: 22% !important;\n  }\n\n  .mobile-selected-products-container {\n    justify-content: space-around;\n  }\n}\n\n@media (max-width: 480px) {\n  .gifting-pick {\n    max-width: 100%;\n  }\n\n  .gifting-box-content {\n    min-width: 100%;\n  }\n\n  .gift-image {\n    height: auto;\n    object-fit: cover;\n  }\n\n  .wrapping-item-slide {\n    width: 55% !important;\n  }\n\n  .gifting-selected-product-container {\n    padding: 2rem 1rem;\n  }\n\n  .gifting-selected-product-containers {\n    padding: 2rem 1rem;\n  }\n\n  .gifting-box-content {\n    margin-top: 2rem;\n  }\n\n  .gifting-image-bottom-container {\n    /* width: 20%; */\n    /* margin-left: 1rem; */\n  }\n\n  .gifting-image-container {\n    /* text-align: center; */\n    margin: 0 0.2rem;\n    width: 60px;\n  }\n}\n\n.gifting-box-content {\n  width: -webkit-fill-available;\n}\n\n/* product list */\n.gifting-product-list-container {\n  display: list-item;\n  width: 100%;\n}\n\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(calc(15% - 20px), 1fr));\n  grid-gap: 20px;\n}\n\n@media (max-width: 768px) {\n  img.gift-image-bottom-summary {\n    max-width: 45px;\n    width: 45px;\n  }\n  .image-wrapper .remove-overlay {\n    font-size: 12px;\n  }\n\n  .product-disclosure {\n    margin: 0 !important;\n    padding: 1rem !important;\n  }\n\n  .product-grid {\n    grid-template-columns: repeat(auto-fill, minmax(calc(50% - 20px), 1fr));\n  }\n\n  .gifting-product-list-container {\n    margin: 2rem 0;\n  }\n\n  .boxwrapping-container {\n    padding: 3rem 1rem !important;\n  }\n\n  .mt-3-mobile {\n    margin-top: 3rem;\n  }\n\n  .right {\n    padding-left: 0 !important;\n  }\n\n  .boxwrapping-list {\n    justify-content: space-between !important;\n  }\n}\n\n.product-item {\n  border: 0;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  width: fit-content;\n}\n\n.product-item-swiper {\n  border: 0;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n}\n\n.product-item .product-item-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding: 0 16px 16px;\n  justify-content: space-between;\n}\n\n.product-item-swiper .product-item-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  padding: 0 16px 16px;\n  justify-content: space-between;\n}\n\n@media (min-width: 847px) {\n  .product-item .product-item-body {\n    padding: 0 12px 12px;\n  }\n\n  /* .gifting-box-content {\n    margin-left: 2rem;\n  } */\n}\n\n.product-image {\n  width: 100%;\n  height: auto;\n}\n\n.product-name {\n  margin: 18px 12px 0px;\n  color: rgb(16, 16, 16);\n}\n\n.product-item .product-name-container .product-name {\n  font-size: 1.1em;\n  text-decoration: none;\n  font-family: custom-body-font, Poppins, sans-serif;\n  line-height: 1.1;\n  display: block;\n  font-weight: 400;\n  min-height: 55px;\n}\n\n.product-item-swiper .product-name-container .product-name {\n  font-size: 1.1em;\n  text-decoration: none;\n  font-family: custom-body-font, Poppins, sans-serif;\n  line-height: 1.1;\n  display: block;\n  font-weight: 400;\n  min-height: 55px;\n}\n\n.product-price {\n  font-size: 1.1em;\n  text-decoration: none;\n  font-family: custom-body-font, roboto-fallback, sans-serif;\n  line-height: 1.1;\n  display: block;\n  font-weight: 400;\n  min-height: 20px;\n  place-content: center;\n  display: flex;\n  flex-direction: column;\n  color: rgb(16, 16, 16);\n  /* padding: 0px 4px; */\n}\n\n.add-to-box-button {\n  margin-top: 10px;\n  padding: 0.6rem 0.5rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 100%;\n  text-transform: uppercase;\n}\n\n.add-to-box-button:hover {\n  background-color: #6f1920;\n  border: 1.5px solid #6f1920 !important;\n  color: white !important;\n}\n.recipient-name-field {\n  max-width: 530px;\n  margin-top: 5rem;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.875rem + 2px);\n  padding: 0.4375rem 1rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #303e48;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #303e48;\n  border-radius: 4px;\n  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n    -webkit-box-shadow 0.15s ease-in-out;\n}\n\n.form-control-area {\n  display: block;\n  width: 100%;\n  min-height: 240px;\n  padding: 0.4375rem 1rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #303e48;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #dbdcdc;\n  border-radius: 4px;\n  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n    -webkit-box-shadow 0.15s ease-in-out;\n}\n\n.message-on-card-container {\n  width: 100%;\n  display: inline-grid;\n}\n\n.card-message-field {\n  max-width: 530px;\n  margin-top: 3rem;\n}\n\n.card-message-field-no-message {\n  max-width: 530px;\n  margin: 1.5rem 0 0 0;\n  margin-bottom: 3rem;\n}\n\n.h3 {\n  font-size: 1.5625rem;\n  font-family: custom-heading-font, andrade-pro-fallback, sans-serif;\n  font-size: 1.5625rem;\n  font-style: normal;\n  line-height: 1.28;\n  letter-spacing: -0.5px;\n  color: #303e48;\n}\n\n.box-button-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 73px;\n  width: 100%;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.left {\n  flex: 1;\n  /* padding-right: 10px; */\n}\n\n.right {\n  flex: 1;\n  padding-left: 10px;\n}\n\n.wishcard-list {\n  display: flex;\n  flex-wrap: wrap;\n  /* justify-content: space-between; */\n}\n\n.mt-3 {\n  margin-top: 3rem;\n}\n\n.wishcard-item {\n  /* width: calc(50% - 10px); */\n  margin-bottom: 20px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  background-color: white;\n  padding: 0.4rem;\n  align-content: center;\n  border-radius: 4px;\n}\n\n.wishcard-item.desktop {\n  /* width: calc(25% - 10px); */\n}\n\n.wishcard-item.selected {\n  border-color: #6f1920;\n}\n\n.wishcard-image {\n  text-align: center;\n  min-height: 210px;\n  align-content: center;\n  object-fit: contain;\n}\n\n.wishcard-details {\n  padding: 10px;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n}\n\n.wishcard-price {\n  padding: 12px;\n  font-size: 1.1em;\n  text-decoration: none;\n  font-family: custom-body-font, roboto-fallback, sans-serif;\n  line-height: 1.1;\n  display: block;\n  font-weight: 400;\n  min-height: 20px;\n  place-content: center;\n  display: flex;\n  flex-direction: column;\n  color: rgb(16, 16, 16);\n}\n\n.wishcard-name {\n  padding: 12px;\n  min-height: 60px;\n  color: rgb(16, 16, 16);\n}\n\n.boxwrapping-left {\n  margin-top: 3rem;\n}\n\n.boxwrapping-right {\n  margin-top: 2rem;\n}\n\n.boxwrapping-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: unset;\n}\n\n.center-image-container {\n  text-align: center;\n  min-height: 210px;\n  align-content: center;\n}\n\n.wrapping-item {\n  /* width: calc(50% - 10px); */\n  margin-bottom: 20px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  background-color: white;\n  padding: 0.4rem;\n  align-content: end;\n  border-radius: 4px;\n}\n\n.wrapping-item.desktop {\n  /* width: calc(25% - 10px); */\n  margin-right: 0.5rem;\n  align-content: end;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.wrapping-item.selected {\n  border-color: #6f1920;\n}\n\n.boxwrapping-item.selected {\n  border-color: #6f1920;\n}\n\n.boxwrapping-image {\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n}\n\n.boxwrapping-details {\n  padding: 10px;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n}\n\n.boxwrapping-price {\n  padding: 12px;\n  font-size: 1.1em;\n  text-decoration: none;\n  font-family: custom-body-font, roboto-fallback, sans-serif;\n  line-height: 1.1;\n  display: block;\n  font-weight: 400;\n  min-height: 20px;\n  place-content: center;\n  display: flex;\n  flex-direction: column;\n  color: rgb(16, 16, 16);\n}\n\n.boxwrapping-name {\n  padding: 12px;\n  min-height: 60px;\n  color: rgb(16, 16, 16);\n}\n\n.boxwrapping-container {\n  padding: 3rem;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n}\n\n.box-item {\n  /* width: calc(50% - 10px); */\n  margin-bottom: 20px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  background-color: white;\n  padding: 0.4rem;\n  border-radius: 4px;\n}\n\n.box-item.desktop {\n  /* width: calc(25% - 10px); */\n  margin-right: 0.5rem;\n}\n.box-item.selected {\n  border-color: #6f1920;\n}\n\n.review-container {\n  background: none;\n}\n\n.summary-gift-items {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.no-mb {\n  margin-bottom: 0;\n}\n\n.gift-item-summary-container {\n  background: #f9f9f9;\n  border-radius: 5px;\n  margin-top: 3rem;\n  margin-right: 0.3rem;\n  padding: 0.2rem;\n  width: 100%;\n}\n\n.gift-item-summary-container {\n  display: flex;\n  flex-wrap: wrap;\n  /* justify-content: space-between; */\n}\n\n.gift-summary-image-container {\n  /* width: calc(25% - 3px); */\n  width: calc(50% - 6px);\n  display: flex;\n  margin: 3px;\n}\n\n.gift-summary-image {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  background: white;\n}\n\n.personalized-item-container {\n  background: #f9f9f9;\n  border-radius: 5px;\n  margin-top: 0.5rem;\n  padding: 5px;\n  width: 100%;\n  align-content: center;\n  display: flex;\n}\n\n.gifting-total-product-price {\n  text-align: right;\n  font-weight: bold;\n}\n\n.gifting-subtotal-product-price {\n  font-size: 15px;\n  color: #7d7d7d;\n  text-align: right;\n  font-weight: bold;\n}\n\n.color-circle {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0 5px;\n  cursor: pointer;\n  border: 1px solid #d4d4d4;\n}\n\n.color-circle.selected {\n  border: 1px solid #373737;\n}\n\n.size-rectangle {\n  padding: 5px 10px;\n  margin: 5px;\n  border: 1px solid #d4d4d4;\n  cursor: pointer;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n.size-rectangle.selected {\n  border: 1px solid black;\n}\n\n/* modal */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-container {\n  position: relative;\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.modal-close-button {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n.modal-content {\n  margin: 20px 10px;\n}\n\n.product-image-in-modal {\n  width: 15rem;\n  height: auto;\n  border-radius: 5px;\n}\n\n.product-image-in-modal-container {\n  text-align: -webkit-center;\n  margin-bottom: 2rem;\n}\n\n.product-image-in-modal-container-content {\n  /* margin: 0 2rem; */\n  text-wrap: pretty;\n}\n\n.product-disclosure {\n  width: 100%;\n  background: #f9f9f9;\n  margin: 1rem 0;\n  padding: 1rem 3rem;\n  text-align-last: left;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n}\n\n#cover-spin {\n  position: fixed;\n  width: 100%;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 9999;\n}\n\n#cover-spin::after {\n  content: '';\n  display: block;\n  position: absolute;\n  left: 48%;\n  top: 40%;\n  width: 40px;\n  height: 40px;\n  border-style: solid;\n  border-color: black;\n  border-top-color: transparent;\n  border-width: 4px;\n  border-radius: 50%;\n  -webkit-animation: spin 0.8s linear infinite;\n  animation: spin 0.8s linear infinite;\n}\n\n.rp-card-gifting-option {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 15px;\n}\n\n.rp-card-gifting-option-values-container {\n  display: flex;\n  flex-direction: row;\n  row-gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.product-price {\n  font-size: 1.1em;\n  text-decoration: none;\n  font-family: custom-body-font, roboto-fallback, sans-serif;\n  line-height: 1.1;\n  display: block;\n  font-weight: 400;\n  min-height: 20px;\n  place-content: center;\n  display: flex;\n  flex-direction: column;\n  color: rgb(16, 16, 16);\n}\n.gift-set-product-image {\n  /* max-width: 120px !important; */\n  /* border-radius: 5px; */\n  margin-bottom: 0.5rem;\n}\n\n.gift-set-option {\n  background: #e2e2e291;\n  padding: 2rem;\n  border-radius: 5px;\n  margin-top: 20px;\n  /* margin: 1rem 0.5rem; Adjust margin for better spacing */\n  /* border: 5px solid #f7f1f0; */\n  cursor: pointer;\n  transition: all 0.3s ease; /* Adding transition for smooth hover effect */\n  width: -webkit-fill-available;\n}\n\n.gift-set-option:hover {\n  transform: translateY(-5px); /* Move the option up by 5px on hover */\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow on hover */\n}\n\n.gift-set-button-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* Use auto-fit for flexible grid */\n  gap: 1rem; /* Gap between images */\n}\n\n@media screen and (max-width: 768px) {\n  .gift-set-button-container {\n    grid-template-columns: repeat(1, 1fr); /* On smaller screens, display one image per row */\n  }\n\n  .gift-set-product-image {\n    /* max-width: 60px !important; */\n  }\n\n  .gift-set-images {\n    display: flex;\n    flex-flow: wrap;\n    align-items: center;\n  }\n}\n\n.gift-set-option-item {\n  display: flex;\n  justify-content: space-between;\n  width: -webkit-fill-available;\n}\n\n.gift-set-images {\n  display: flex;\n  flex-flow: wrap;\n  align-items: center;\n}\n\n.button-next-page {\n  cursor: pointer;\n  background: #6f1920;\n  border-radius: 3px;\n  color: white;\n  width: 100%;\n  padding: 0.6rem 1rem;\n  margin-top: 1rem;\n}\n\n.button-next-page:hover {\n  background: #2e1414 !important;\n}\n\n.swiper-button-prev,\n.swiper-button-next {\n  color: #000000 !important;\n}\n\n.svg-hover:hover {\n  color: #6f1920;\n}\n\n.remove-icon{\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
